const NOTIFICATION_INBOX_CACHE = 'boozeon-notification-inbox-v1';
const NOTIFICATION_INBOX_URL = '/__boozeon_notification_inbox__';

const canUseCacheStorage = () => (
    typeof window !== 'undefined' && 'caches' in window
);

export const drainWorkerNotificationInbox = async email => {
    if (!canUseCacheStorage()) return [];
    try {
        const cache = await window.caches.open(NOTIFICATION_INBOX_CACHE);
        const response = await cache.match(`${NOTIFICATION_INBOX_URL}/${encodeURIComponent(email?.trim().toLowerCase() || '')}`);
        const notifications = response ? await response.json() : [];
        await cache.delete(`${NOTIFICATION_INBOX_URL}/${encodeURIComponent(email?.trim().toLowerCase() || '')}`);
        return Array.isArray(notifications) ? notifications : [];
    } catch {
        return [];
    }
};

export const clearWorkerNotificationInbox = async email => {
    if (!canUseCacheStorage()) return;
    try {
        const cache = await window.caches.open(NOTIFICATION_INBOX_CACHE);
        await cache.delete(`${NOTIFICATION_INBOX_URL}/${encodeURIComponent(email?.trim().toLowerCase() || '')}`);
    } catch {
        // The local in-app inbox can still be cleared when Cache Storage is unavailable.
    }
};

// Missing recipient metadata is unsafe: legacy shared inbox entries are discarded.
export const isVenueNotificationFor = (notification, email) => {
    const data = notification?.data || notification || {};
    return Boolean(email && data.recipientType === 'VENUE' &&
        typeof data.recipientId === 'string' &&
        data.recipientId.trim().toLowerCase() === email.trim().toLowerCase());
};
